import React from 'react'
import { isMobile } from '../../helpers/mobileresize/Mobileresize'
import WebDealDetail from './web/DealDetail'
import MobileDealDetail from './mobile/DealDetail'

const index2 = () =>{
    if(isMobile){
        return(
            <div>
                <MobileDealDetail />
            </div>
        )
    }else{
        return(
            <div>
                <WebDealDetail />
            </div>
        )
    }
}

export default index2